export const SET_IA_AGENT_UI_FLAG = 'SET_IA_AGENT_UI_FLAG';
export const CLEAR_IA_AGENTS = 'CLEAR_IA_AGENTS';
export const SET_IA_AGENTS = 'SET_IA_AGENTS';
export const SET_IA_AGENT_ITEM = 'SET_IA_AGENT_ITEM';
export const SET_IA_AGENT_ASSISTANTS = 'SET_IA_AGENT_ASSISTANTS';
export const SET_IA_AGENT_KNOWLEDGE_SOURCES = 'SET_IA_AGENT_KNOWLEDGE_SOURCES';
export const ADD_IA_AGENT_KNOWLEDGE_SOURCE = 'ADD_IA_AGENT_KNOWLEDGE_SOURCE';
export const REMOVE_IA_AGENT_KNOWLEDGE_SOURCE = 'REMOVE_IA_AGENT_KNOWLEDGE_SOURCE'; 